import { render, staticRenderFns } from "./ProductByRowList.vue?vue&type=template&id=4ca0ac3c&scoped=true"
import script from "./ProductByRowList.vue?vue&type=script&lang=ts"
export * from "./ProductByRowList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca0ac3c",
  null
  
)

export default component.exports